var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "copy-panel" },
    [
      _c(
        "span",
        { staticClass: "material-icons", staticStyle: { "font-size": "30px" } },
        [_vm._v("ads_click")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "text" }, [
        _vm._v(_vm._s(_vm.$t("chatbotv2.selectPlaceToCopy"))),
      ]),
      _vm._v(" "),
      _c(
        "a-button",
        {
          attrs: { type: "primary" },
          on: {
            click: function ($event) {
              return _vm.changeCopyMode(null)
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("message.cancel")))]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }